import PANE from '../../../../../APP/page/pane/PANE.js';
import { text } from '../../../../../DOM/text/TEXT.js';
import { heading } from '../../../../../DOM/heading/HEADING.js';
import { hr } from '../../../../../DOM/hr/HR.js';
export default class PANE_Home_Faq extends PANE {
    constructor(node, model) {
        super(node, model);
        this.addClass('full-frame');
        this.addClass('ethics-faq');
        this.addHeading(heading(1, 'Frequently Asked Questions'));
        this.addHeading(heading(2, 'A collection of common inquiries'));
        this.addP(text('Lorem Ipsum:'));
        this.addHR(hr());
        let endpoint = 'core/messagebus/version';
        this.logInfo('Initial Endpoint', endpoint);
        // TODO: Create a list of FAQs
    }
}
